import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Names } from '@ils/static/names.js';
import { ILSUser } from './ils-user.js';

@Entity()
export class ILSUserOverviewLineOrder extends AdornisEntity {
  static override _class = Names.ILSUserOverviewLineOrder._class;

  @Field(type => ID)
  _id!: string;
  @Field(type => ID)
  examDayID!: string;
  @Field(type => ID)
  paymentIntent!: string;
}

@Entity()
export class ILSUserOverviewLineExamDayCandidate extends AdornisEntity {
  static override _class = Names.ILSUserOverviewLineExamDayCandidate._class;

  static override resolveID(entity: any): string {
    return entity.examDayID;
  }
  @Field(type => ID)
  examDayID!: string;
  @Field(type => String)
  name!: string;
}

@Entity()
export class ILSUserOverviewLine extends AdornisEntity {
  static override _class = Names.ILSUserOverviewLine._class;

  static override resolveID(entity: any): string {
    return entity.user._id;
  }

  @Field(type => ILSUser)
  user!: ILSUser;

  @Field(type => [ILSUserOverviewLineExamDayCandidate])
  candidateOfExamDays!: ILSUserOverviewLineExamDayCandidate[];

  @Field(type => [ILSUserOverviewLineOrder])
  ordersOnExamDays!: ILSUserOverviewLineOrder[];
}
